/**
 * Format a Date as YYYY-MM-DD in the browser's local timezone.
 * Avoids UTC day-shift bugs from Date#toISOString() when building calendar ranges.
 */
export function formatLocalYmd(d) {
  if (!d) return '';
  if (d instanceof Date) {
    if (Number.isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
  if (typeof d === 'string' && d.length >= 10) {
    return d.slice(0, 10);
  }
  return '';
}

/**
 * FullCalendar passes [start, end) with end exclusive. Last calendar day inside the range
 * is one millisecond before end — more reliable than setDate(getDate()-1) across TZ/DST.
 */
export function lastInclusiveYmdFromEndExclusive(endExclusive) {
  if (!endExclusive || !(endExclusive instanceof Date)) return '';
  const t = endExclusive.getTime() - 1;
  if (!Number.isFinite(t) || t < 0) return '';
  return formatLocalYmd(new Date(t));
}

/**
 * Normalize API date fields to YYYY-MM-DD for range checks and FullCalendar strings.
 * Handles ISO strings, Jackson [year,month,day] arrays, and plain objects.
 */
export function normalizeCalendarDate(input) {
  if (input == null || input === '') return '';
  if (typeof input === 'string') {
    return input.length >= 10 ? input.slice(0, 10) : '';
  }
  if (Array.isArray(input) && input.length >= 3) {
    const y = Number(input[0]);
    const m = Number(input[1]);
    const d = Number(input[2]);
    if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return '';
    return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
  }
  if (typeof input === 'object' && input !== null) {
    if (
      typeof input.year === 'number' &&
      typeof input.monthValue === 'number' &&
      typeof input.dayOfMonth === 'number'
    ) {
      return `${input.year}-${String(input.monthValue).padStart(2, '0')}-${String(input.dayOfMonth).padStart(2, '0')}`;
    }
    if (typeof input.year === 'number' && typeof input.month === 'number' && typeof input.day === 'number') {
      return `${input.year}-${String(input.month).padStart(2, '0')}-${String(input.day).padStart(2, '0')}`;
    }
  }
  if (input instanceof Date) {
    return formatLocalYmd(input);
  }
  return '';
}
